<template>
    <div class="page">
        <div class="header">
            <Header :current="['zx']"></Header>
            <div class="header-search">
                <a-input-search
                    placeholder="输入搜索内容"
                />
            </div>
        </div>
        <div class="content">
            <div class="policy-container">
                <div class="service-card">
                    <div class="service-card-div">
                        <p class="service-card-title">{{ res.title }}</p>
                        <div v-for="(item, i) in res.list" :key="i" class="service-card-list">
                            <router-link :to="'/portal/articles?title='+'政策信息&id='+item.id" target="_blank">
                                <p>{{ item.title }}</p><p>{{ item.date }}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { reactive } from 'vue'
import {useRoute} from "vue-router"
import {getPolicyList} from "@/api/policy"
export default {
    name: "CardMore",
    setup() {
        const res = reactive({
            title: '',
            list: []
        })
        const route = useRoute()
        return {
            res,
            route
        }
    },
    mounted() {
        this.initList()
    },
    methods: {
        async initList() {
            const query = this.route.query
            this.res.title = query.title
            const params = {
                "current": 1,
                "model": {
                    "secondCategoryId": query.id,
                },
                "size": 1024,
            }
            const data = await getPolicyList(params)
            this.res.list = data.records
        },
        handleClick() {
            console.log(1)
        }
    },
    components: {
        Header,
        Footer
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_business_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            .header-search {
                width 600px
                height 70px
                margin 200px auto
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            padding 70px 0
            .policy-container {
                width 100%
                margin-bottom 70px
                .policy-container-title {
                    width 100%
                    background-image url("../../assets/img/portal_policy_title_bg.png")
                    background-repeat no-repeat
                    background-position-x center
                    background-position-y center
                    text-align center
                    margin-bottom 75px
                }
                .policy-container-title p:first-child {
                    font-size 46px
                    color #000
                    font-weight bold
                }
                .policy-container-title p:last-child {
                    font-size 35px
                    color #CECECE
                }
                .service-card {
                    width 100%
                    min-height 470px
                    max-width 1700px
                    margin 0 auto
                    background rgba(82, 135, 185, 0.08)
                    box-shadow 0 3px 35px rgba(0, 0, 0, 0.16)
                    border-radius 16px
                    display flex
                    flex-wrap wrap
                    .service-card-div {
                        width 100%
                        height 100%
                        padding 50px 90px 50px 180px
                        overflow-y auto
                        .service-card-title {
                            font-size 34px
                            font-weight bold
                            color #167ADA
                            margin-bottom 45px
                        }
                        .service-card-list {
                            width 100%
                            font-size 24px
                            position relative
                            padding-left 30px
                            margin-bottom 20px
                            border-bottom 1px dotted #707070
                            cursor pointer
                        }
                        .service-card-list a {
                            color #000
                            width 100%
                            display flex
                        }
                        .service-card-list::before {
                            content ''
                            width 17px
                            height 17px
                            position absolute
                            top 12px
                            left 0
                            background-color #167ADA
                            border-radius 50%
                        }
                        .service-card-list p:first-child {
                            width 65%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        }
                        .service-card-list p:last-child {
                            width 30%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            text-align right
                        }
                    }
                }
            }
        }
    }
</style>